/* eslint-disable jsx-a11y/anchor-is-valid */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import Avatar from 'components/Avatar';
import { UserCard } from 'components/Card';
import { LOGIN_USER_TYPE, USER_TYPE_STORAGE_KEY } from 'constants/USER_TYPES';
import useCustomToast from 'hooks/useCustomToasts';
import useUsuario from 'hooks/useUsuario';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { ListGroup, ListGroupItem, Popover, PopoverBody } from 'reactstrap';
import { dataUsuario } from 'redux/actions/aLogin';
import { dataUsuarioVacio } from '../../constants';
import { URL_INGRESAR_AIGGO_MB } from './constants';
import './publicNavbar.scss';
import { APLICATIVOS } from 'constants/aplicativos';

const API = ApiKeyFetch.instance();

const MiPerfilPopover = () => {
  const { userIsLoggedIn, usu_tipo_usuario, ...datosUsuario } = useSelector(
    (state) => state.datosUsuarios.dataUsuario
  );

  const { addWarningToast } = useCustomToast();
  const [isOpenPopover, setIsOpenPopover] = useState(false);

  const usuario = useUsuario();

  const history = useHistory();
  const dispatch = useDispatch();
  const togglePopover = () => {
    setIsOpenPopover(!isOpenPopover);
  };

  const showIf = (params) => {
    return params.includes(usu_tipo_usuario);
  };

  const showIfNotIncludes = (params) => {
    return !showIf(params);
  };

  const onClickSalir = (event) => {
    event.preventDefault();
    event.stopPropagation();
    togglePopover();
    localStorage.setItem('login', false);
    dispatch(dataUsuario(dataUsuarioVacio));
    const userType = localStorage.getItem(USER_TYPE_STORAGE_KEY);
    history.push(`/login?user=${LOGIN_USER_TYPE[userType]}`);
  };

  const onClickRedireccionAigGoMb = (app) => async () => {
    const response = await API.post(URL_INGRESAR_AIGGO_MB, {
      idUsuario: datosUsuario.cliCodigoCore,
      app,
    });

    if (response?.transaccion && response?.data?.usuarioValido && response?.data?.urlRedireccion) {
      window.location.href = response?.data?.urlRedireccion;
      return;
    }

    addWarningToast('Ha ocurrido un problema al momento de redireccionar al aplicativo solicitado');
  };

  return (
    <React.Fragment>
      <li className="ml-auto my-auto mr-2 nav__font__source__sans__pro">
        <a id="Popover2" className="cpointer text-white my-auto">
          {usuario?.fullName}
          <Avatar onClick={togglePopover} className="can-click ml-2 mb-1" />
        </a>
        <Popover
          placement="bottom-end"
          isOpen={isOpenPopover}
          toggle={togglePopover}
          target="Popover2"
          className="width-popover-mex"
        >
          <PopoverBody className="p-0 ">
            <UserCard
              title={`${datosUsuario.nombres} ${datosUsuario.apellidos}`}
              subtitle={datosUsuario.correo}
              //text="Last updated 3 mins ago"
              className=" menu-derecho-user"
              style={{
                backgroundImage: 'linear-gradient(to bottom, #0035aa, #001871)',
              }}
            >
              <ListGroup flush>
                <Link to={`/listado-cotizaciones`} onClick={togglePopover}>
                  <ListGroupItem
                    tag="button"
                    action
                    className="set-cursor lista-menu-user-izquierda"
                  >
                    Listado de Cotizaciones
                  </ListGroupItem>
                </Link>

                <Link to={`/listado-pre-polizas`} onClick={togglePopover}>
                  <ListGroupItem
                    tag="button"
                    action
                    className="set-cursor lista-menu-user-izquierda"
                  >
                    Listado de Pre Polizas
                  </ListGroupItem>
                </Link>

                <Link to={`/listado-polizas`} onClick={togglePopover}>
                  <ListGroupItem
                    tag="button"
                    action
                    className="set-cursor lista-menu-user-izquierda"
                  >
                    Listado de Polizas
                  </ListGroupItem>
                </Link>

                <Link to={`/listado-polizas-certificados`} onClick={togglePopover}>
                  <ListGroupItem
                    tag="button"
                    action
                    className="set-cursor lista-menu-user-izquierda"
                  >
                    Generación de Certificados
                  </ListGroupItem>
                </Link>

                {showIfNotIncludes('cliente') && !usuario?.sso && (
                  <Link to={`/cambiar-contrasenia`} onClick={togglePopover}>
                    <ListGroupItem
                      tag="button"
                      action
                      className="set-cursor lista-menu-user-izquierda"
                    >
                      Cambiar Contraseña
                    </ListGroupItem>
                  </Link>
                )}

                {showIfNotIncludes('cliente') && (
                  <Link to={`/mi-perfil`} onClick={togglePopover}>
                    <ListGroupItem
                      tag="button"
                      action
                      className="set-cursor lista-menu-user-izquierda"
                    >
                      Perfil
                    </ListGroupItem>
                  </Link>
                )}

                {/* {showIf('agente-user') && (
                  <ListGroupItem
                    tag="button"
                    action
                    className="set-cursor lista-menu-user-izquierda"
                    onClick={onClickRedireccionAigGoMb(APLICATIVOS.CANCELACIONES)}
                  >
                    Ir a cancelaciones
                  </ListGroupItem>
                )} */}

                <ListGroupItem
                  tag="button"
                  onClick={onClickSalir}
                  className="set-cursor text-left lista-menu-user-izquierda"
                >
                  Salir
                </ListGroupItem>
              </ListGroup>
            </UserCard>
          </PopoverBody>
        </Popover>
      </li>
    </React.Fragment>
  );
};

export default MiPerfilPopover;
